module.exports = __webpack_public_path__ + "static/927101-bdce43b01fdbb8c8e6078d817de6fe6d.jpg";